import React, { memo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import request from '../../utils/request';
import { isSuccess } from '../../utils/utils';
import { trans } from '../../localization';
import { setGeneralSuccess } from '../../layout/components/UniversalModal/actions';
import { loginWithoutUsernameOption } from '../../authentication/actions';

import { MIGRATE_ACTION, OPEN_MODAL_ACTIONS } from './const';
import { openOtpWebView } from './utils';

import MigrationConfirmModal from './MigrationConfirmModal';

const MigrationConfirm = memo(props => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [migrateAction, setMigrateAction] = useState(null);
  const [managerList, setManagerList] = useState([]);
  const [isClosed, setIsClosed] = useState(false);
  const [closable, setClosable] = useState(false);

  const { 
    currentRestaurant,
    setGeneralSuccessConnect,
    loginWithoutUsernameOptionConnect,
  } = props;
  const {
    restaurant_id: restaurantId,
    name: restaurantName,
  } = currentRestaurant;

  async function handleAgree() {
    const response = await request.postMerchant('/api/store/migration/agree');
    if (isSuccess(response)) {
      setIsOpen(false);
      setIsConfirmOpen(true);
    }
  }

  useEffect(() => {
    async function handleOtpMessage(e) {
      if (e.origin !== CONFIG.OTP_OVER_SMS.HOST) return;

      const authCode = get(e, 'data.auth_code');
      if (authCode) {
        const response = await request.postMerchant('/api/user/verify_phone', {
          auth_code: authCode,
        });

        if (isSuccess(response)) {
          setMigrateAction(MIGRATE_ACTION.CONFIRM_MIGRATION);
          handleAgree();
        } else if (response.result === 'error_switch_account') {
          setGeneralSuccessConnect(
            trans('error_switch_account'), 
            {
              extraActions: [
                {
                  name: trans('btn_re_login'),
                  onClick: () => loginWithoutUsernameOptionConnect(),
                },
              ],
              withCloseButton: false,
            },
          );
        }
      }
    };

    window.addEventListener('message', handleOtpMessage);

    return () => {
      window.removeEventListener('message', handleOtpMessage);
    };
  }, [setGeneralSuccessConnect, loginWithoutUsernameOptionConnect]);

  useEffect(() => {
    setIsClosed(false);
  }, [restaurantId]);

  useEffect(() => {
    if (restaurantId && !isClosed) {
      request.postMerchant('/api/store/migration/status').then(response => {
        if (isSuccess(response)) {
          const { migrate_action: _migrateAction, manager_list: _managerList, popup_status: _popupStatus } = response.reply;
          if (OPEN_MODAL_ACTIONS.includes(_migrateAction)) {
            setMigrateAction(_migrateAction);
            setManagerList(_managerList)
            setIsOpen(true);
            // 1 可以关闭 2 不能关闭
            setClosable(_popupStatus === 1)
          }
        }
      });
    }
  }, [restaurantId, isClosed]);

  function handleConfirm() {
    if (migrateAction === MIGRATE_ACTION.BIND_PHONE) {
      openOtpWebView();
    } else {
      handleAgree();
    }
  }

  function handleClose() {
    setIsClosed(true);
  }

  return (
    <MigrationConfirmModal
      isOpen={isOpen}
      closable={closable}
      setIsOpen={setIsOpen}
      isConfirmOpen={isConfirmOpen}
      setIsConfirmOpen={setIsConfirmOpen}
      migrateAction={migrateAction}
      restaurantId={restaurantId}
      restaurantName={restaurantName}
      managerList={managerList}
      onConfirm={handleConfirm}
      onClose={handleClose}
    />
  );
});

MigrationConfirm.displayName = 'MigrationConfirm';

const mapStateToProps = state => ({
  currentRestaurant: state.setting.currentRestaurant,
});

const mapDispatchToProps = {
  setGeneralSuccessConnect: setGeneralSuccess,
  loginWithoutUsernameOptionConnect: loginWithoutUsernameOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(MigrationConfirm);



// WEBPACK FOOTER //
// ./foody/src/components/migration-confirm/MigrationConfirm.jsx